import {Helmet} from 'react-helmet-async';
// import { Link } from 'react-router-dom';
import {useTranslation} from 'react-i18next';

const Participate = () => {
    const {t} = useTranslation();

    return (
        <>
            <Helmet>
                <title>SpaceTime | Participate</title>
                <meta name="description" content="Participate in the Project and our community initiatives."/>
                <meta property="og:title" content="SpaceTime | Participate" key="ogtitle"/>
                <meta property="og:description"
                      content="Discover more about the SpaceTime Project, our mission, and how to get involved."
                      key="ogdesc"/>
                <meta property="og:url" content="https://spacetime.community/about"/>
                <meta name="twitter:card" content="summary_large_image"/>
            </Helmet>

            {/* Icon Section */}
            <div className='simple-page contact-page-container'>
                <div className='row justify-content-center'>

                    <div className="content-area">
                        <h1 className="content-title">{t("Get Involved")}</h1>
                        <h2 className="content-sub-title">{t("Πώς μπορείς να συμμετέχεις;")}</h2>
                        <div className="content-text">
                            <ul>
                                <li>Πάρε μέρος σε μια από τις δράσεις μας.</li>
                                <li>Τρέξε το δικό σου workshop.</li>
                                <li>Βοηθά μας να κάνουμε upgrade το εργαστήριο.</li>
                                <li>Μοίρασε μας την τεχνογνωσία σου τις ιδέες σου.</li>
                                <li>Μια δωρέα θα μας βοηθήσει απίστευτα, δεν χρειάζεται να παλεύουμε κάθε φορά για τα τελείως βασικά (νερό,ρεύμα,ενίκοιο).</li>
                            </ul>
                            <p>Επικοινώνησε μαζί μας στο info@spacetime.community και γίνε μέρος της προσπάθειας η απλά πέρασε μια βόλτα από το εργαστήριο!</p>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default Participate;
